<template>
  <div class="position-relative" style="height: 0px;">
    <div
      class="innside-tog-wrap"
      :class="homeRoute == 'home' ? 'd-none' : 'd-block'"
      @click="togNa()"
    >
      <span class="innside-tog ins-tog1"></span>
      <span class="innside-tog ins-tog2"></span>
      <span class="innside-tog ins-tog3"></span>
    </div>
    <div :key="$route.path + '_sidebar'" class="innside-wrap">
      <ul
        class="list-group innside-wrap"
        style="min-height: 524px;"
        v-if="menu.length > 0"
      >
        <li v-for="(link, index) in menu" :key="'innersidebar_' + index">
          <a
            v-if="link.children.length > 0"
            class="list-group-item dropdown collapsed"
            :class="{ 'active-item': shouldActive(link) }"
            data-toggle="collapse"
            :href="'#collapse' + index"
            role="button"
            aria-expanded="false"
            :aria-controls="'collapse' + index"
          >
            {{ link.title }}
          </a>
          <router-link
            v-else
            class="list-group-item no-dropdown"
            :class="{ 'active-item': $route.path == link.href }"
            :to="link.href"
          >
            {{ link.title }}
          </router-link>
          <div
            class="collapse"
            :class="{ show: shouldActive(link) }"
            v-if="link.children.length > 0"
            :id="'collapse' + index"
          >
            <ul class="list-unstyled">
              <li
                v-for="(clink, cindex) in link.children"
                :key="'innersidebar_' + cindex"
              >
                <router-link
                  :to="clink.href"
                  class="ml-3 m-1 mr-3 pl-3 p-1 nested-list"
                  :class="{
                    'active-item': replaceSpace($route.path) == clink.href,
                  }"
                >
                  {{ clink.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <div class="list-group" v-else-if="$store.state.inner_sidebar_loader">
        <small class="p-3">Aan het laden....</small>
      </div>

      <div
        v-else-if="
          menu.length === 0 && $store.state.inner_sidebar_loader == false
        "
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "inner_sidebar",
  computed: {
    menu() {
      return this.$store.state.inner_sidebar;
    },
  },
  data() {
    return {
      homeRoute: "",
    };
  },
  methods: {
    shouldActive(item) {
      return item.children.find(
        (d) => d.href == this.$route.path.replaceAll("%20", " ")
      )
        ? true
        : false;
    },
    replaceSpace(link) {
      return link.replaceAll("%20", " ");
    },
    togNa() {
      window.$(".innside-wrap").toggleClass("navActive");
      window.$(".ins-tog1").toggleClass("ins-tog1Act");
      window.$(".ins-tog2").toggleClass("ins-tog2Act");
      window.$(".ins-tog3").toggleClass("ins-tog3Act");
    },
  },
  created() {
    this.homeRoute = this.$route.name;
  },
};
</script>

<style scoped>
/*.dropdown{
        background: #4192D9;
        color: white !important;
    }*/
.dropdown:after {
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  content: "\f0da";
  font-weight: 900;
  float: right;
}
.dropdown:hover {
  background: #4192d9 !important;
  color: white !important;
}
.list-group-item:hover{
    color: white !important;
}
.list-group li:hover{
    color: rgb(129, 114, 114) !important;
}
.dropdown.collapsed {
  color: black ;
}
.nested-list {
  text-decoration: none;
  color: black;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
  display: block;
  font-size: 14px;
}
.nested-list.active-item {
  color: #4192d9 !important;
  background: transparent;
  box-shadow: none;
}
.nested-list.active-item::after {
  display: none !important;
}
.nested-list:hover {
  color: #4192d9;
}
.no-dropdown:after {
  display: none !important;
}
@media (max-width: 768px) {
  .innside-wrap {
    width: 210px;
    position: absolute;
    z-index: 999;
    background: #cfe4f6 !important;
    top: -8px;
    left: -210px;
    transition: 0.5s ease;
    box-shadow: 0px 19px 8px #00000052;
  }
  .navActive {
    left: -11px;
  }
  .ins-tog1Act {
    transform: rotate(131deg);
    position: absolute;
    top: 6px;
  }
  .ins-tog2Act {
    transform: rotate(45deg);
    position: absolute;
    top: 6px;
  }
  .ins-tog3Act {
    display: none;
  }
}
@media (max-width: 650px) {
  .innside-wrap {
    top: 0px;
  }
}
@media (max-width: 580px) {
  .innside-tog-wrap {
    position: relative;
    top: -106px;
    left: -2px;
    width: fit-content;
  }
  .innside-wrap {
    top: -36px;
  }
}
@media (max-width: 650px) {
}
</style>
